<template>
    <div class="list__body__group">
        <div class="list__body__group__header capitalize">{{ $t(`global.${data.header.translate || data.header.value}`) }}</div>
        <div
            v-if="data.header.type === 'default'"
            class="list__body__group__value">
            {{ finalValue || '---' }}
        </div>
        <div
            v-if="data.header.type === 'date'"
            class="list__body__group__value">
            {{ parseUtcToLocalDate({ date: finalValue, originFormat: data.header.originFormat, finalFormat: data.header.finalFormat }) || '---' }}
        </div>
        <template v-else-if="data.header.type === 'component'" >
            <component
                :is="data.header.component"
                v-bind="{
                    ...properties
                }"
            />
        </template>
    </div>
</template>

<script>
// packages
import { ref } from '@vue/composition-api';

// hooks
import getValue from '@/hooks/get-value';

// utils
import { haveProperty, parseUtcToLocalDate } from '@/utils/';

// lang
import i18n from '@/plugins/i18n';

// constants
import { roleList } from '@/configs/const';

export default {
    props: {
        data: Object
    },
    setup ({ data: { header, row } }, { root: { $route } }) {
        // obtenção do valor.
        const { value } = getValue( header.value, row, $route );

        // validação se é necessário traduzir.
        // nesta fase é apenas os roles.
        const finalValue = !header.isNecessaryTranslate ? value.value : i18n.t( `roles.${roleList[value.value]}` );

        // definção das propriedades do componente
        const properties = ref({
            ...( !haveProperty( header, 'itsAnInput' ) ? {
                value: finalValue,
                data: row
            } : {
                settings: {
                    label: { class: 'field__label--hide', text: i18n.t( 'global.independentCaller' ) },
                    input: {
                        component: 'InputToggle', // nesta fase ainda só é necessário apresentar um tipo de input
                        name: `${header.value}-${row.id}`,
                        id: `${header.value}-${row.id}`,
                        value: finalValue ? 1 : 0
                    },
                    allowFilling: false
                }
            })
        });

        return { finalValue, properties, parseUtcToLocalDate };
    }
};
</script>